import peopleaiService from "../services/peopleai";
import { SET_CAMPAIGN_LIST, SET_FAILED_MESSAGE, SET_SINGLE_CAMPAIGN_DETAIL, SET_SINGLE_CAMPAIGN_DETAIL_PROFILES, SET_SINGLE_CAMPAIGN_DETAIL_PROFILES_LOADER, SET_SUCCESS_MESSAGE } from "./types";

export const getCampaignListAction = (page, limit, search, status) => async (dispatch) => {
  return await peopleaiService.getCampaignList(page, limit, search, status).then(async (resp) => {
    if (resp.status) {
      dispatch({ type: SET_CAMPAIGN_LIST, payload: resp?.data, count: resp?.count });
    } else {
      dispatch({ type: SET_CAMPAIGN_LIST, payload: {} });
    }
    return resp;
  });
};


export const getSingleCampaignDetailAction = (campaignId, page, limit, search, status) => async (dispatch) => {
  if (page === 1) {
    dispatch({ type: SET_SINGLE_CAMPAIGN_DETAIL_PROFILES_LOADER, payload: true })
  }
  return await peopleaiService.getSingleCampaignDetail(campaignId, page, limit, search, status).then(async (resp) => {
    if (resp.status) {
      dispatch({ type: SET_SINGLE_CAMPAIGN_DETAIL, payload: resp?.data?.campaign, count: resp?.profilesCount });
      dispatch({ type: SET_SINGLE_CAMPAIGN_DETAIL_PROFILES, payload: resp?.data?.profiles })
    } else {
      dispatch({ type: SET_SINGLE_CAMPAIGN_DETAIL, payload: {} });
    }
    return resp;
  });
};


export const getProfileByIdsAction = (payload) => (dispatch) => {
  return peopleaiService.getProfileById(payload).then((resp) => {
    if (resp.status) {
      return resp;
    }
    return Promise.resolve();
  });
};

export const reviewCampaignAction = (campaignId, flag = true, filterBody = null) => (dispatch) => {
  return peopleaiService.reviewCampaign(campaignId, flag).then((resp) => {
    if (resp.status) {
      dispatch({
        type: SET_SUCCESS_MESSAGE,
        payload: resp.data,
      });
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
  });
};

export const addProfileToCampaignAction = (payload) => (dispatch) => {
  return peopleaiService.addProfileToCampaign(payload).then((resp) => {
    if (resp?.status) {
      dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.message });
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp?.message || resp.data });
    }
    return resp;
  });
};
